import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface User {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  avatar: string;
  storeId: number;
  store: {
    id: string;
    name: string;
    logo: string;
    document?: string;
    canRenewFreeTime: boolean;
    whatsappPopupDismissed: boolean;
    parentCompanyId?: boolean;
  };
}

export const useUserStore = create(
  persist<{
    user: User | null;
    access_token: string | null;
    setUser: (user: User | null) => void;
  }>(
    (set) => ({
      user: null,
      access_token: null,
      setUser: (data: any) => {
        localStorage.setItem("access_token", data.access_token);
        return set({
          user: {
            ...data.user,
          },
          access_token: data.access_token,
        });
      },
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
